import { create } from "zustand";

export interface FilterQuery {
  search: string;
  page: number;
  [key: string]: string | number | boolean | Date | undefined | null;
}

interface StoreState {
  filter: Partial<FilterQuery>;
  getFilter: () => Partial<FilterQuery>;
  updateFilter: (newFilter: Partial<FilterQuery>, replace?: boolean) => void;
}

const useFilterStore = create<StoreState>((set, get) => ({
  filter: {},

  getFilter: () => get().filter,

  updateFilter: (newFilter, replace = false) => {
    if (replace) {
      set({ filter: newFilter });
    } else {
      set((state) => ({
        filter: {
          ...state.filter,
          ...newFilter,
        },
      }));
    }
  },
}));

export default useFilterStore;
